'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectAssign = require('object-assign');

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _camelize = require('camelize');

var _camelize2 = _interopRequireDefault(_camelize);

var _glamor = require('@headspace/glamor');

var _breakpoints = require('./breakpoints');

var _breakpoints2 = _interopRequireDefault(_breakpoints);

var _grid = require('./grid');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ret = {};
/**
 * Generates margin and paddings for xl, m, and s breakpoints
 */

function generateSpacing(prop, l, s, isOverride) {
  var _spacing;

  var spacing = (_spacing = {}, _defineProperty(_spacing, prop, s), _defineProperty(_spacing, '@media(min-width: ' + _breakpoints2.default.l + 'px)', _defineProperty({}, prop, l)), _spacing);

  if (isOverride) {
    return (0, _glamor.css)(_defineProperty({}, ':nth-child(n)', (0, _objectAssign2.default)(_defineProperty({}, '@media screen', _defineProperty({}, prop, s)), spacing)));
  }

  return (0, _glamor.css)(spacing);
} // all spacing is from style guide


var sizes = {
  auto: ['auto', 'auto'],
  none: [0, 0],
  xxxsmall: [6, 6],
  xxsmall: [12, 12],
  xsmall: [16, 8],
  smaller: [24, 12],
  small: [32, 16],
  medium: [40, 32],
  mediumlarge: [56, 48],
  large: [80, 64],
  xlarge: [80, 64],
  xxlarge: [128, 96]
};
Object.keys(sizes).forEach(function (sizeName) {
  var _assign2;

  (0, _objectAssign2.default)(ret, (_assign2 = {}, _defineProperty(_assign2, (0, _camelize2.default)('marginBottom-' + sizeName), generateSpacing.apply(undefined, ['marginBottom'].concat(_toConsumableArray(sizes[sizeName])))), _defineProperty(_assign2, (0, _camelize2.default)('marginTop-' + sizeName), generateSpacing.apply(undefined, ['marginTop'].concat(_toConsumableArray(sizes[sizeName])))), _defineProperty(_assign2, (0, _camelize2.default)('marginLeft-' + sizeName), generateSpacing.apply(undefined, ['marginLeft'].concat(_toConsumableArray(sizes[sizeName])))), _defineProperty(_assign2, (0, _camelize2.default)('marginRight-' + sizeName), generateSpacing.apply(undefined, ['marginRight'].concat(_toConsumableArray(sizes[sizeName])))), _defineProperty(_assign2, (0, _camelize2.default)('paddingTop-' + sizeName), generateSpacing.apply(undefined, ['paddingTop'].concat(_toConsumableArray(sizes[sizeName])))), _defineProperty(_assign2, (0, _camelize2.default)('paddingBottom-' + sizeName), generateSpacing.apply(undefined, ['paddingBottom'].concat(_toConsumableArray(sizes[sizeName])))), _defineProperty(_assign2, (0, _camelize2.default)('paddingLeft-' + sizeName), generateSpacing.apply(undefined, ['paddingLeft'].concat(_toConsumableArray(sizes[sizeName])))), _defineProperty(_assign2, (0, _camelize2.default)('paddingRight-' + sizeName), generateSpacing.apply(undefined, ['paddingRight'].concat(_toConsumableArray(sizes[sizeName])))), _defineProperty(_assign2, (0, _camelize2.default)('padding-' + sizeName), generateSpacing.apply(undefined, ['padding'].concat(_toConsumableArray(sizes[sizeName])))), _defineProperty(_assign2, (0, _camelize2.default)('margin-' + sizeName), generateSpacing.apply(undefined, ['margin'].concat(_toConsumableArray(sizes[sizeName])))), _assign2));
}); // overrides use sparingly
// this to built to override breakpoint
// scoped padding event on small

ret.overrideMarginRightSmall = generateSpacing.apply(undefined, ['marginRight'].concat(_toConsumableArray(sizes.small), [true]));
ret.overridePaddingSmall = generateSpacing.apply(undefined, ['padding'].concat(_toConsumableArray(sizes.small), [true]));
ret.overrideMarginRightNone = generateSpacing.apply(undefined, ['marginRight'].concat(_toConsumableArray(sizes.none), [true]));

var gutterSize = function gutterSize(prop) {
  var _nthChildN;

  return _defineProperty({}, ':nth-child(n)', (_nthChildN = {}, _defineProperty(_nthChildN, '@media screen', _defineProperty({}, prop, _grid.gutterWidths.base + 'px')), _defineProperty(_nthChildN, '@media (min-width: ' + _breakpoints2.default.base + 'px)', _defineProperty({}, prop, _grid.gutterWidths.m + 'px')), _defineProperty(_nthChildN, '@media (min-width: ' + _breakpoints2.default.m + 'px)', _defineProperty({}, prop, _grid.gutterWidths.l + 'px')), _defineProperty(_nthChildN, '@media (min-width: ' + _breakpoints2.default.l + 'px)', _defineProperty({}, prop, _grid.gutterWidths.xl + 'px')), _nthChildN));
};

(0, _objectAssign2.default)(ret, {
  marginRightGutter: gutterSize('marginRight'),
  marginLeftGutter: gutterSize('marginLeft'),
  marginBottomGutter: gutterSize('marginBottom'),
  marginTopGutter: gutterSize('marginTop'),
  paddingRightGutter: gutterSize('paddingRight'),
  paddingLeftGutter: gutterSize('paddingLeft'),
  paddingBottomGutter: gutterSize('paddingBottom'),
  paddingTopGutter: gutterSize('paddingTop')
});
exports.default = ret;